import service from "@/store/services/logs-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  log: {},
  meta: {},
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, log) => {
    state.log = log;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((log) => {
      commit("SET_RESOURCE", log);
    });
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  log: (state) => state.log,
};

const logs = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default logs;
